import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { useCheckout } from '@/contexts/checkoutContext';
import { postData } from '@/utils/postData';

export const useRemoveDiscountCode = () => {
  const { setCheckoutData } = useCheckout();

  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: postData(Endpoint.ClearDiscountCode),
    onSuccess: data => {
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );

      if (data.isSuccess) {
        setCheckoutData(data.data);

        queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });
      }
    },
  });

  return { clearDiscountCode: mutate, isPending };
};
